import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Zoom from '@material-ui/core/Zoom';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TypographyWithTooltip from 'components/shared/TypographyWithTooltip';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  panelClosed: {
    fontSize: '13px',
    color: isExpanded => (isExpanded ? theme.palette.white : theme.palette.primary.main),
    display: 'flex',
    alignItems: 'center',
    textTransform: 'none',
    justifyContent: 'space-between',
    backgroundColor: isExpanded =>
      isExpanded ? theme.palette.secondary.main : theme.palette.background.lightBlue,
    height: '40px',
    padding: '0 16px',
    boxShadow: 'unset',
    border: 'unset',
    outline: 'none'
  },
  title: {
    fontSize: '13px',
    fontWeight: theme.typography.fontWeightBold
  },
  icon: {
    fontSize: '20px',
    width: '20px',
    height: '20px'
  },
  arrow: {
    color: isExpanded => (isExpanded ? theme.palette.white : theme.palette.secondary.main)
  },
  expanded: {
    '& .MuiAccordionSummary-root': {
      color: theme.palette.white,
      backgroundColor: theme.palette.secondary.main
    }
  },
  children: {
    width: '100%',
    display: 'block',
    padding: 0
  },
  link: {
    textDecoration: 'none',
    color: isExpanded => (isExpanded ? theme.palette.white : theme.palette.primary.main),
    '&:link &:visited &:active': {
      color: isExpanded => (isExpanded ? theme.palette.white : theme.palette.primary.main)
    }
  }
}));

const SidebarMenuExpansionPanel = ({ title, children, id, expanded, handleChange, ...rest }) => {
  const isExpanded = expanded === id;

  const classes = useStyles(isExpanded);

  return (
    <div>
      <Accordion expanded={isExpanded} className={isExpanded ? classes.expanded : ''}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon onClick={handleChange} id={id} className={classes.arrow} />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className={classes.panelClosed}
          {...rest}
        >
          <TypographyWithTooltip
            variant="subtitle1"
            className={classes.title}
            gutterBottom
            tooltipProps={{
              title,
              placement: 'right',
              TransitionComponent: Zoom,
              arrow: true
            }}
          >
            <Link to={`/canned/${id}`} className={classes.link}>
              {title}
            </Link>
          </TypographyWithTooltip>
        </AccordionSummary>
        <AccordionDetails className={classes.children}>{children}</AccordionDetails>
      </Accordion>
    </div>
  );
};

SidebarMenuExpansionPanel.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.string,
  handleChange: PropTypes.func.isRequired
};
SidebarMenuExpansionPanel.defaultProps = {
  expanded: null
};

export default SidebarMenuExpansionPanel;
